<template>
  <div class="cookie-comply__modal">
    <div class="cookie-comply__modal-middle">
      <div class="cookie-comply__modal-inner">
        <header class="cookie-comply__modal-header">
          <slot name="modal-header">
            <h3>{{ $t('cookieModal.header') }}</h3>
          </slot>
        </header>
  
        <main class="cookie-comply__modal-content">
          <div
            v-for="(preference, index) in preferences"
            :key="index"
          >
            <slot
              name="modal-body"
              :preference="preference"
              :index="index"
            >
              <h2>{{ preference.title }}</h2>
              <p>{{ preference.description }}</p>
              <div
                v-for="item in preference.items"
                :key="item.value"
                class="cookie-comply__modal-switches"
              >
                <h3>{{ item.label }}</h3>
                <div>
                  <v-checkbox
                    v-model="item.checked"
                    hide-details
                    :disabled="item.disabled"
                    color="#EE730F"
                    style="size: large;"
                  />
                </div>
              </div>
            </slot>
          </div>
        </main>
        <footer class="cookie-comply__modal-footer">
          <slot name="modal-footer">
            <div class="cookie-comply__buttons">
              <cookie-comply-button
                style="background-color:#EE730F; color:white"
                @handleClick="onSaveConfiguration"
              >
                {{ $t('buttons.accept') }}
              </cookie-comply-button>
              <cookie-comply-button @handleClick="closeModal">
                {{ $t('buttons.back') }}
              </cookie-comply-button>
            </div>
          </slot>
        </footer>
      </div>
    </div>
  </div>
</template>
  
<script>
import CookieComplyButton from './CookieComplyButton.vue';
///import Cookies from 'js-cookie';

  
export default {
  name: 'CookieComplyModal',
  components: {
    CookieComplyButton
  },
  props: {
  },
  emits: [ 'cookie-comply-save', 'cookie-comply-close' ],
  data() {
    return {
      checkedValues: [],
      preferences: []
    };
  },
  mounted(){
    this.preferences = [
      {
        title: this.$t('cookieModal.basicCookies'),
        description:
            this.$t('cookieModal.basicCookiesDescription'),
        items: [ { label: this.$t('cookieModal.mandatory'), value: 'requiredCookies', isRequired: true, checked: true, disabled:true} ]
      },
      {
        title: this.$t('cookieModal.analytics'),
        description:
            this.$t('cookieModal.analyticsDescription'),
        items: [
          { label: this.$t('buttons.accept'), value: 'analyticsCookies', checked: false}
        ]
      },
      {
        title: this.$t('cookieModal.thirdPartyCookies'),
        description:
            this.$t('cookieModal.thirdPartyCookiesDescription'),
        items: [
          { label: this.$t('buttons.accept'), value: 'thirdPartyCookies', checked: false }
        ]
      }
    ];
  },
  methods: {
    onSaveConfiguration() {
      let cookieMap = {
        requiredCookies: true,
        analyticsCookies: this.preferences[1].items[0].checked,
        thirdPartyCookies: this.preferences[2].items[0].checked };
      this.$emit('cookieComplySave', cookieMap);
    },
    closeModal() {
      this.$emit('cookieComplyModalClose');
    }
  }
};
</script>
  
  <style>
  .cookie-comply__modal {
    display: table;
    position: fixed;
    top: 0;
    left: 0;
    height: 100%;
    width: 100%;
    background-color: var(--background-overlay);
    z-index: 99;
  }
  
  .cookie-comply__modal-middle {
    display: table-cell;
    vertical-align: middle;
    min-width: 600px;
  }
  
  .cookie-comply__modal-inner {
    position: relative;
    margin-left: auto;
    margin-right: auto;
    width: 600px;
    min-width: 600px;
    padding: var(--spacing-lg);
    background-color: var(--color-white);
    border-radius: var(--spacing-sm);
    box-shadow: var(--box-shadow);
  }
  
  .cookie-comply__back-arrow {
    position: absolute;
    left: var(--spacing-lg);
    cursor: pointer;
  }
  
  .cookie-comply__modal-content {
    overflow-y: auto;
    max-height: 60vh;
    min-width: 300px;
    text-align: left;
    padding-right: var(--spacing-md);
  }
  
  .cookie-comply__modal-switches {
    display: flex;
    justify-content: space-between;
    align-items: center;
    border-bottom: var(--border-color-lightest);
    padding: var(--spacing-md) 0;
  }
  
  .cookie-comply__modal-header {
    border-bottom: var(--border-color-light);
    padding-bottom: var(--spacing-md);
    margin-bottom: var(--spacing-md);
  }
  
  .cookie-comply__modal-header h3 {
    margin: 0;
    font-size: 1.5rem;
  }
  
  .cookie-comply__modal-footer {
    border-top: var(--border-color-light);
    padding-top: var(--spacing-lg);
    margin-top: var(--spacing-lg);
  }
  
  .cookie-comply__buttons {
    display: flex;
    justify-content: center;
    gap: var(--spacing-md);
  }
  
  @media (max-width: 680px) {
    .cookie-comply__modal-middle {
      display: block;
      min-width: 0;
      padding: 0;
      height: 100%;
      overflow-y: auto;
      padding-top: 64px;
    }
  
    .cookie-comply__modal-inner {
      width: 100%;
      min-width: 0;
      margin: 0;
      height: calc(100% - 64px);
      border-radius: 0;
      display: flex;
      flex-direction: column;
      padding: 0;
    }
  
    .cookie-comply__modal-content {
      flex: 1;
      overflow-y: auto;
      max-height: none;
      padding: var(--spacing-md);
      margin-top: 56px;
    }
  
    .cookie-comply__modal-header {
      position: fixed;
      top: 64px;
      left: 0;
      right: 0;
      background: var(--color-white);
      z-index: 2;
      padding: var(--spacing-md);
      margin: 0;
      border-bottom: var(--border-color-light);
    }
  
    .cookie-comply__modal-header h3 {
      font-size: 1.25rem;
    }
  
    .cookie-comply__modal-switches {
      padding: var(--spacing-sm) 0;
    }
  
    .cookie-comply__modal-switches h3 {
      font-size: 1rem;
    }
  
    .cookie-comply__buttons {
      flex-direction: column;
      gap: var(--spacing-sm);
      padding: var(--spacing-md);
    }
  
    .cookie-comply__button {
      width: 100%;
    }
  
    .cookie-comply__modal-footer {
      padding: var(--spacing-md);
      margin: 0;
      border-top: var(--border-color-light);
    }
  }
  </style>
